import React from 'react';
import { Route, Switch } from 'react-router-dom';
import * as Unauth from '../../unauth/';

const PrimeLandingLayout: React.FC<{}> = () => {
    return (
        <React.Fragment>
            <Switch>
                <Route render={() => <Unauth.PrimeLanding />} />
            </Switch>
        </React.Fragment>
    );
};

export default PrimeLandingLayout;
